/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowCircularLeft16: {
  name: 'arrow-circular-left-16';
  data: string;
} = {
  name: 'arrow-circular-left-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m1.284 1.284 1.058 1.058a8 8 0 0 1 11.314.002A8 8 0 1 1 0 7.953a2.525 2.525 0 0 0 .775.052l1.225-.109a6 6 0 1 0 1.757-4.14l1.059 1.059a.5.5 0 0 1-.31.851l-3.908.347a.5.5 0 0 1-.542-.547l.378-3.878a.5.5 0 0 1 .85-.304z" fill-rule="evenodd"/></svg>`
};
